import { getScoreTier } from '../data/scoreRules';
import { SaveSystem } from './SaveSystem';

export type ScoreChangeCallback = (delta: number, total: number, silent?: boolean) => void;

export class ScoreSystem {
  private points: number;
  private onChange?: ScoreChangeCallback;

  constructor(initialPoints = 0, onChange?: ScoreChangeCallback) {
    this.points = ScoreSystem.sanitize(initialPoints);
    this.onChange = onChange;
  }

  static fromSave(onChange?: ScoreChangeCallback): ScoreSystem {
    const save = SaveSystem.load();
    return new ScoreSystem(save.rafflesiaPoints, onChange);
  }

  private static sanitize(value: number): number {
    if (!Number.isFinite(value) || Number.isNaN(value)) return 0;
    return Math.max(0, Math.round(value));
  }

  getScore(): number {
    return this.points;
  }

  getPoints(): number {
    return this.getScore();
  }

  addScore(amount: number, _reason?: string, silent = false): void {
    const delta = ScoreSystem.sanitize(amount);
    if (delta === 0) return;
    this.points = ScoreSystem.sanitize(this.points + delta);
    SaveSystem.save({ rafflesiaPoints: this.points });
    this.onChange?.(delta, this.points, silent);
  }

  /** Tampilkan feedback skor tanpa mengubah poin (mis. pilihan salah = +0) */
  showScoreFeedback(amount: number): void {
    this.onChange?.(ScoreSystem.sanitize(amount), this.points);
  }

  subtractScore(amount: number, _reason?: string): void {
    const delta = ScoreSystem.sanitize(amount);
    if (delta === 0) return;
    this.points = ScoreSystem.sanitize(this.points - delta);
    SaveSystem.save({ rafflesiaPoints: this.points });
    this.onChange?.(-delta, this.points);
  }

  addPoints(amount: number, reason?: string): void {
    this.addScore(amount, reason);
  }

  getTier(): string {
    return getScoreTier(this.points);
  }

  reset(): void {
    this.points = 0;
    SaveSystem.save({ rafflesiaPoints: 0 });
    this.onChange?.(0, 0);
  }
}
